import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  position: relative;
  grid-area: pricing;

  ${mediaQueryUp.tablet} {
    justify-self: end;
  }
`

function AccommodationSameRoomOptionTilePricing(props: PropsWithChildren) {
  return <Container
    {...props}
    direction="vertical"
    verticalAlign="end"
    gap={12}
  />
}

export default AccommodationSameRoomOptionTilePricing
